let ControllerName = 'Articles';
const ArticlesController = Object.freeze({
    TrendingArticles: `${ControllerName}/trending-articles`,
    TrendingTags: `${ControllerName}/trending-tags`,
    ArticleById: `${ControllerName}/article-by-id`,
    LoadMoreComments: `${ControllerName}/load-more-comments`,
    FilterArticles: `${ControllerName}/filter-articles`,
});

export default ArticlesController;